import {setActiveProductBatchStocksAction} from '../../_flux/actions/product_batch_stocks_actions';
import {setActiveProductAction} from '../../_flux/actions/active_product_actions';
import {
    openAction,
    openPostcodeLayerAction,
    closeProductLayerAction,
    closeOrderFormLayerAction, closeOrderStatusLayerAction,
    setQuantityAction, hideItemPriceDetails, hideShippingPriceDetails,
    unsetErrorMessageAction, unsetPaymentStatus, unsetOrderAction,
    unsetFittingPriceInDetailModeAction, unsetTimerIntervalId,
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import getDefaultQuantity from '../../_flux/components/product_mixed_stocks/helper/get_default_quantity';
import PostcodeStore from '../../_flux/stores/postcode_store';
import ActiveProductBatchStocksStore from '../../_flux/stores/product_batch_stocks/active_product_batch_stocks_store';
import ProductMixedStocksLightboxStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import onCartMixedStocksComputeRequest from '../../_views/product_mixed_stocks/on_cart_mixed_stocks_compute_request';
function openAlternativeProductStockOnClick(product, batchStocks) {
    const postcode = PostcodeStore.getState().appliedPostcode;
    const oldActiveProductBatch = ActiveProductBatchStocksStore.getState().activeProductBatchStocks;
    const sku = product.sku;
    const batchStocksSku = batchStocks.id.value;
    const defaultQuantity = getDefaultQuantity(batchStocks.body.mixedStocksAvailableQuantity);
    const {cart, timerIntervalId} = ProductMixedStocksLightboxStore.getState();
    let shouldRequestMixedStocksCompute = false;
    if (!oldActiveProductBatch
        || (oldActiveProductBatch && sku !== oldActiveProductBatch.id.value)
        || null === cart) {
        shouldRequestMixedStocksCompute = true;
        setActiveProductAction(product);
        setActiveProductBatchStocksAction(batchStocks);
        setQuantityAction(defaultQuantity);
    }

    unsetErrorMessageAction();
    if (postcode.length > 0) {
        if (shouldRequestMixedStocksCompute) {
            if (null !== timerIntervalId) {
                clearInterval(timerIntervalId);
                unsetTimerIntervalId();
            }
            unsetPaymentStatus();
            unsetOrderAction();
            unsetFittingPriceInDetailModeAction();
            hideItemPriceDetails();
            hideShippingPriceDetails();
            onCartMixedStocksComputeRequest(postcode, batchStocksSku, defaultQuantity, true);
        }
    } else {
        openPostcodeLayerAction();
        closeProductLayerAction();
        closeOrderStatusLayerAction();
        closeOrderFormLayerAction();
    }

    openAction();
}

export default openAlternativeProductStockOnClick;
